import { useEffect, useRef, type ReactNode } from 'react'

export function Logo() {
  return (
    <a className="brand" href="/" aria-label="Lucie's Book home">
      <span className="brand-mark" aria-hidden="true">L</span>
      <span>Lucie's Book</span>
    </a>
  )
}

export function ArrowIcon({ direction = 'right' }: { direction?: 'left' | 'right' }) {
  return <span className={`arrow arrow-${direction}`} aria-hidden="true">{direction === 'left' ? '←' : '→'}</span>
}

export function SiteHeader({ simple = false, onBack }: { simple?: boolean; onBack?: () => void }) {
  return (
    <header className={`site-header ${simple ? 'site-header-simple' : ''}`}>
      <div className="shell nav-inner">
        {simple
          ? <button className="icon-button" onClick={onBack} aria-label="Go back"><ArrowIcon direction="left" /></button>
          : <Logo />}
        {simple && <Logo />}
        {!simple && (
          <nav aria-label="Main navigation">
            <a href="/books/">Shop books</a>
            <a href="/#how-it-works">How it works</a>
            <a className="button button-small" href="/books/">Choose a book <ArrowIcon /></a>
          </nav>
        )}
        {simple && <span className="header-spacer" />}
      </div>
    </header>
  )
}

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="shell footer-grid">
        <div>
          <Logo />
          <p>Every child deserves their own book.</p>
        </div>
        <div className="footer-links">
          <a href="mailto:support@luciesbook.com">Support</a>
          <span>© {new Date().getFullYear()} Lucie's Book</span>
        </div>
      </div>
    </footer>
  )
}

export function Modal({ children, onClose, labelledBy }: { children: ReactNode; onClose: () => void; labelledBy: string }) {
  const closeButton = useRef<HTMLButtonElement>(null)
  useEffect(() => {
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    closeButton.current?.focus()
    const closeOnEscape = (event: KeyboardEvent) => event.key === 'Escape' && onClose()
    window.addEventListener('keydown', closeOnEscape)
    return () => {
      document.body.style.overflow = previousOverflow
      window.removeEventListener('keydown', closeOnEscape)
    }
  }, [onClose])
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={e => e.target === e.currentTarget && onClose()}>
      <section className="modal-card" role="dialog" aria-modal="true" aria-labelledby={labelledBy}>
        <button ref={closeButton} className="modal-close" onClick={onClose} aria-label="Close">×</button>
        {children}
      </section>
    </div>
  )
}

export function Spinner({ label = 'Working' }: { label?: string }) {
  return <span className="spinner" role="status" aria-label={label} />
}
